<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">
          <el-form-item label="操作人账号">
            <el-input
              v-model="form.orderId"
              placeholder="请输入操作人账号"
              style="width: 260px"
            ></el-input>
          </el-form-item>

          <el-form-item label="操作时间">
            <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>
        <template slot="tableColumn">
          <el-table-column
            prop="createTimeL"
            label="编号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTimeL"
            label="操作人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTimeL"
            label="操作模块"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTimeL"
            label="操作内容"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTimeL"
            label="IP地址"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTimeL"
            label="操作时间"
            align="center"
          ></el-table-column>
        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/depositWithdraw/selectList",
      timeDate: [],
      form: {
        orderId: "",
        startDate: "",
        endDate: "",
      },
    };
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      this.timeDate = [];
    },
  },
};
</script>